export const getDeletedRecordOriginalValue = (val: string) => {
  const stringSplitted = val.split('_');
  return stringSplitted[stringSplitted.length - 1];
};
